import WishlistItemList from './wishlist-item-list'
export default WishlistItemList
